export default __webpack_public_path__ + "static/5-unique-ways-to-experience-french-delicacies-cheese-6a3d51a7dfbaffbb432138b91d4f62be.jpg";